/**
 * On stacked inbox layouts (mobile), scroll the chat pane below the conversation list.
 * @param {HTMLElement | null | undefined} paneEl
 * @param {{ desktopMinWidthPx?: number }} options — match the layout breakpoint (lg=1024, xl=1280)
 */
export function scrollInboxPaneIntoView(paneEl, { desktopMinWidthPx = 1024 } = {}) {
  if (typeof window === "undefined" || !paneEl) return () => {};
  if (window.matchMedia(`(min-width: ${desktopMinWidthPx}px)`).matches) return () => {};

  const run = () => {
    paneEl.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  const t1 = window.setTimeout(run, 120);
  const t2 = window.setTimeout(run, 480);

  return () => {
    window.clearTimeout(t1);
    window.clearTimeout(t2);
  };
}
